import { useSelector } from 'react-redux';
import * as WebPushLogService from 'services/messaging/logs/webpush';

export const useWebPushLogService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchWebPushLogs = async (options = {}) => {
    const { error, payload } = await WebPushLogService.read({ ...options, token });
    if (error) {
      return {
        logs: [],
        size: 0
      };
    }

    const {
      data: logs,
      meta: { size }
    } = payload;
    return { logs, size };
  };

  const searchWebPushLogs = async (keys, keyword, options = {}) => {
    const { error, payload } = await WebPushLogService.search(keys, keyword, { ...options, token });
    if (error) {
      return { logs: [], size: 0 };
    }

    const {
      data: logs,
      meta: { size }
    } = payload;
    return { logs, size };
  };

  return { fetchWebPushLogs, searchWebPushLogs };
};
